import 'html/include/js/om/om';
import 'html/include/js/zepto.min';
import 'html/include/js/jquery.unveil';
import SerpReviews from '@atomic/organisms/serp/reviews';
import SerpContactSection from '@atomic/organisms/serp/contact-section';
import AOSerpFAQs from '@atomic/organisms/serp/faqs';
import AOTruncateText from '@atomic/organisms/truncate-text/truncate-text';
import AOCarouselSlider from '@atomic/organisms/serp/carousel-slider';
import {
  byUserInteraction,
  byWindowAction,
  getBreakpointMinWidth,
  initializeAmplitudeSync,
  initializeSaleTopBanner,
  initiateAppBanner,
  initializeSignupAndSavePopup,
  initLazyLoad,
  initUserInteraction,
  initWindowAction,
  loadAsyncCss,
  parameters,
  sendAmplitudeEvent,
  sendGoogleEvent,
  abTests,
  initParameters,
} from '@html/_common/utils';
import { lighthouseNavigationInitiate, trustBannerInitiate } from '@html/_common/header_script';
import LiveChat from '@html/_modules/live-chat';
import AOStickyMenu from '@atomic/organisms/sticky-menu/sticky-menu';
import AOPaxTravelers
  from '@atomic/organisms/_common/pax-selector/travelers/pax-travelers';
import AOPaxMonth from '@atomic/organisms/_common/pax-selector/month/pax-month';
import AOPaxTravelersMenu from '@atomic/organisms/_common/pax-selector/travelers/menu/pax-travelers-menu';
import AOPaxMonthMenu from '@atomic/organisms/_common/pax-selector/month/menu/pax-month-menu';
import StickyMenu from '@scout/components/sticky-menu/index';
import AOCommunityBanner from '@atomic/organisms/_common/banners/community/community-banner';

export default function LighthouseScript() {
  const MOBILE_WIDTH = getBreakpointMinWidth('s2') - 1;

  const IMAGE_SIZES = {
    mobile: '360x210',
    desktop: '1171x320',
  };

  const isInMobileWidth = (width) => width <= MOBILE_WIDTH;
  const $mapImages = $('.js-tour-card-images__map-link__picture--full-width');

  const stickyMenu = new AOStickyMenu();
  stickyMenu.initiate();

  const reviews = new SerpReviews();
  reviews.initiate();

  const contactSection = new SerpContactSection();
  contactSection.initiate();

  const faqs = new AOSerpFAQs();
  faqs.initiate();

  const truncateText = new AOTruncateText();
  truncateText.initiate();

  const carouselSlider = new AOCarouselSlider();
  carouselSlider.initiate();

  const communityBanner = new AOCommunityBanner();
  communityBanner.initiate();

  let selectedMonth = 'initial';
  const initializeLazyLoadedBackgroundImagesObserver = () => {
    const lazyBackgrounds = [].slice.call(document.querySelectorAll('.ao-lazy-background'));

    if ('IntersectionObserver' in window) {
      const lazyBackgroundObserver = new IntersectionObserver(((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('ao-lazy-background--visible');
            lazyBackgroundObserver.unobserve(entry.target);
          }
        });
      }));

      lazyBackgrounds.forEach((lazyBackground) => {
        lazyBackgroundObserver.observe(lazyBackground);
      });
    }
  };

  const initiatePaxSelector = () => {
    const stickyMenuTravelers = new StickyMenu({ selector: '.js-ao-pax-travelers-sheet' });
    stickyMenuTravelers.initiateWithoutOpening();

    const stickyMenuMonth = new StickyMenu({ selector: '.js-ao-pax-month-sheet' });
    stickyMenuMonth.initiateWithoutOpening();

    const paxTravelers = new AOPaxTravelers(stickyMenuTravelers);
    paxTravelers.initiate();

    const paxMonth = new AOPaxMonth(stickyMenuMonth);
    paxMonth.initiate();

    const paxTravelersMenu = new AOPaxTravelersMenu(true);
    paxTravelersMenu.initiate();

    const paxMonthMenu = new AOPaxMonthMenu(true);
    paxMonthMenu.initiate();
  };

  const uncriticalCSSFallbackLoad = () => {
    const uncriticalCssElem = document.getElementById('async-uncritical-css');

    if (uncriticalCssElem?.getAttribute('rel') === 'preload') {
      uncriticalCssElem.rel = 'stylesheet';
    }
  };
  const goToSerp = (link) => {
    const months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
    let serpLink = link.replaceAll('@', '/');
    if (selectedMonth !== 'initial') {
      serpLink = `${serpLink}#month=${selectedMonth}`;
    }
    if ($('.js-ao-pax-month').attr('data-pax-month')) {
      const month = $('.js-ao-pax-month').attr('data-pax-month');
      const year = $('.js-ao-pax-month').attr('data-pax-year');
      let travelers = '';

      if ($('.js-ao-pax-travelers').attr('data-pax-adults')) {
        travelers = `,adults=${$('.js-ao-pax-travelers').attr('data-pax-adults')}`;
      }
      if ($('.js-ao-pax-travelers').attr('data-pax-children')) {
        travelers = `${travelers},children=${$('.js-ao-pax-travelers').attr('data-pax-children')}`;
      }
      serpLink = `${serpLink}#month=${months[month - 1]}-${year}${travelers}`;
    }
    window.location.href = serpLink;
  };

  const handleInteraction = () => {
    const $asyncCssPathElem = $('#async_css_path');
    loadAsyncCss($asyncCssPathElem.val());
    ['scroll', 'keydown', 'keyup', 'mousemove', 'touchend', 'touchmove'].forEach((e) => {
      window.removeEventListener(e, handleInteraction);
    });
  };

  const getDeviceType = (width) => {
    if (isInMobileWidth(width)) {
      return 'mobile';
    }
    return 'desktop';
  };

  const initResizeMap = () => {
    const currentPageWidth = $(window).width();

    const deviceType = getDeviceType(currentPageWidth);
    const imageSizeToUse = IMAGE_SIZES[deviceType];

    $mapImages.each((index, item) => {
      const currentImageUrl = $(item).attr('src');
      const currentDataImageUrl = $(item).data('src');

      // eslint-disable-next-line prefer-regex-literals
      const regex = new RegExp('\\/\\d+x\\d+\\/');
      const newImageUrl = currentImageUrl.replace(regex, `/${imageSizeToUse}/`);
      const newImageDataUrl = currentDataImageUrl.replace(regex, `/${imageSizeToUse}/`);

      $(item).attr('src', newImageUrl);
      $(item).data('src', newImageDataUrl);
    });
  };

  const initResizeMapInit = () => {
    if ($mapImages.length === 0) {
      return;
    }

    if (isInMobileWidth) {
      initResizeMap();
    }

    byWindowAction(['resize'], () => {
      initResizeMap();
    });
  };

  this.initiate = () => {
    initParameters();

    if (document.readyState !== 'loading') {
      initializeLazyLoadedBackgroundImagesObserver();
      uncriticalCSSFallbackLoad();
    } else {
      document.addEventListener('DOMContentLoaded', initializeLazyLoadedBackgroundImagesObserver);
      document.addEventListener('DOMContentLoaded', uncriticalCSSFallbackLoad);
    }

    const monthSelectElement = document.querySelector('.js-aa-dropdown');
    if (monthSelectElement) {
      monthSelectElement.addEventListener('change', (event) => {
        selectedMonth = event.target.value;
      });
    }

    const serpTopButton = document.querySelector('.js-serp-top-button');
    const serpCtaButtons = document.querySelectorAll('.js-serp-cta-button');
    const serpSliderCtaButton = document.querySelector('.js-ao-clp-carousel-slider__navigation-see-all-tours');
    const serpPaxButton = document.querySelector('.js-serp-pax-button');

    if (serpTopButton) {
      serpTopButton.addEventListener('click', () => {
        goToSerp(serpTopButton.dataset.serp);
      });
    }

    if (serpPaxButton) {
      serpPaxButton.addEventListener('click', (event) => {
        const $monthElement = $(event.target).parent().find('.js-ao-pax-month');
        const $paxElement = $(event.target).parent().find('.js-ao-pax-travelers');
        const month = $monthElement.attr('data-pax-month');
        const year = $monthElement.attr('data-pax-year');
        const adults = $paxElement.attr('data-pax-adults');
        const children = $paxElement.attr('data-pax-children');

        sendAmplitudeEvent({
          ampEventName: 'lighthouse_view_tours_clicked',
          selected_date: `${year}-${month}`,
          selected_pax: `adults ${adults} & children ${children}`,
        });

        goToSerp(serpPaxButton.dataset.serp);
      });
    }

    if (serpCtaButtons) {
      serpCtaButtons.forEach((serpCtaButton) => {
        serpCtaButton.addEventListener('click', () => {
          goToSerp(serpCtaButton.dataset.serp);
        });
      });
    }

    if (serpSliderCtaButton) {
      serpSliderCtaButton.addEventListener('click', () => {
        goToSerp(serpSliderCtaButton.dataset.cta);
      });
    }

    document.querySelectorAll('.js-timeline-show-more').forEach((timelineShowMoreButton) => {
      timelineShowMoreButton.addEventListener('click', (e) => {
        const $clickedShowMore = $(e.currentTarget);
        $clickedShowMore.addClass('hid');
        const $parent = $clickedShowMore.parent();
        const timelineElements = $parent.find('.scout-timeline__item');
        $(timelineElements).removeClass('scout-timeline__item-no-distance');
        $(timelineElements).removeClass('scout-timeline__item-hid');
      });
    });

    $('.js-lac-links-month-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-serp-demographic-links__card-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-scout-component-mini-card__button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-category-links__more-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-season-month__card__months-item__header-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });
    $('.js-link-to-button').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-link').replaceAll('@', '/');
    });

    $('.js-ao-clp-carousel-slider__navigation-see-all-tours').on('click', (event) => {
      event.preventDefault();
      window.location.href = event.currentTarget.getAttribute('data-cta-button').replaceAll('@', '/');
    });

    const heroAnchor = document.querySelector('.hero');
    const itinerayHeroAnchor = document.querySelector('.itinerary-hero');

    if (heroAnchor) {
      heroAnchor.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }

    if (itinerayHeroAnchor) {
      itinerayHeroAnchor.addEventListener('click', (e) => {
        e.preventDefault();
      });
    }

    document.querySelectorAll('.tour-card__button-brochure').forEach(($downloadBrochureButton) => {
      $downloadBrochureButton.addEventListener('click', () => {
        const tdpLink = $downloadBrochureButton.dataset.tdp.replaceAll('@', '/');
        window.location.href = `${tdpLink}?open_download_brochure=true`;
      });
    });

    const $asyncCssPathElem = $('#async_css_path');
    if ($asyncCssPathElem.length) {
      ['scroll', 'keydown', 'keyup', 'mousemove', 'touchend', 'touchmove'].forEach((e) => {
        window.addEventListener(e, handleInteraction);
      });
    }

    const isLiveChatButtonExist = !!document.getElementById('live-chat');
    const common = {
      sendGoogleEvent,
      sendAmplitudeEvent,
      byUserInteraction,
      parameters,
    };
    this.liveChat = new LiveChat(!isLiveChatButtonExist, common);

    if (parameters.isTravelPlannerLighthouseExperimentEligible) {
      abTests.exposure('lighthouse_travel_planner');
    }

    initLazyLoad();
    trustBannerInitiate();
    lighthouseNavigationInitiate();
    initializeSaleTopBanner();
    initWindowAction();
    initUserInteraction();
    initResizeMapInit();
    initializeAmplitudeSync();
    initiateAppBanner();
    initializeSignupAndSavePopup();
    initiatePaxSelector();
  };
}
